import React, { Component } from "react";
import { View, Text } from "react-native";
import styles from "../../src/styles/chatStyles";

export default class TimerMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: null,
      counter: 5,
    };
  }

  // on load page.
  componentDidMount() {
    this.startTimer();
  }
  // to manage the counter
  manageTimer = () => {
    const { counter } = this.state;

    if (counter === 0) {
      // clearInterval(this.state.timer);
      this.setState({
        counter: 5,
      });
    } else {
      this.setState({
        counter: this.state.counter - 1,
      });
    }
  };

  // to start the counter
  startTimer = () => {
    let timer = setInterval(this.manageTimer, 1000);
    this.setState({ timer });
  };

  render() {
    return (
      <View>
        <Text style={styles.timerTextMsg}>
          {"This page will be closed in " + this.state.counter + " seconds."}
        </Text>
      </View>
    );
  }
}
